import { Component, input } from '@angular/core';

/**
 * The strip between the top bar and the content: what this page is showing on
 * the left, what you can do about it on the right.
 *
 * Mark each control with `toolbarFilters` or `toolbarActions`, not a wrapper
 * around them: the toolbar lines them up itself, centred on one row with the
 * same gap, so a lone "Novo produto" and the period select beside "Novo pedido"
 * sit the same way. On a list, the primary action is the last one, a plain
 * `p-button` with `pi pi-plus`.
 */
@Component({
    selector: 'app-page-toolbar',
    template: `
        <div class="page-toolbar">
            <div class="page-toolbar__summary">
                @if (summary()) {
                    <span class="page-toolbar__text">{{ summary() }}</span>
                }
                <ng-content select="[toolbarFilters]" />
            </div>

            <div class="page-toolbar__actions">
                <ng-content select="[toolbarActions]" />
            </div>
        </div>
    `,
    styles: `
        .page-toolbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 0.75rem;
            margin-bottom: 1rem;
        }

        .page-toolbar__summary,
        .page-toolbar__actions {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            flex-wrap: wrap;
            /* A wide filter wraps or scrolls inside its side instead of widening the page. */
            max-width: 100%;
        }

        /*
         * Actions too wide to sit beside the summary take a row of their own and keep to its right end, the primary
         * action last. On a phone they stack from the left like the rest of the page.
         */
        @media (min-width: 576px) {
            .page-toolbar__actions {
                margin-left: auto;
                justify-content: flex-end;
            }
        }

        .page-toolbar__text {
            color: var(--p-text-muted-color);
            font-size: 0.8125rem;
        }
    `
})
export class PageToolbarComponent {
    readonly summary = input('');
}
